export default "__VITE_ASSET__3269f7fd__"